<template>
  <div>
    <div>
      <breadcrumb :breadcrumb_link="program_breadcrumb" />
    </div>
    <div class="header">
      <h1 class="overlay">PROGRAM INFORMATION</h1>
      <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>

    <div class="container">
      <div class="row d-flex justify-content-center">
        <div class="text-center col-lg-12 mt-5 mb-4">
          <h2>
            <strong>{{ $t('program_title') }}</strong>
          </h2>
        </div>
        <div class="col-lg-12 text-center mb-5" style="margin-bottom: 30px">
          <p>{{ $t('program_desc') }}</p>
        </div>
        <div class="col-lg-12 mb-5 program_info"></div>
        <!--
        <div class="embed-responsive embed-responsive-16by9 mb-5">
          <iframe
            class="embed-responsive-item"
            src="https://player.vimeo.com/video/570206717?byline=0&portrait=0&title=0&background=0&autoplay=1&loop=1"
            allowfullscreen
            allow="autoplay"
          >
          </iframe>
        </div>
        -->
      </div>
      <div class="container">
        <div class="row d-flex">
          <div v-for="(item, index) in program_items" :key="index" class="col-lg-4 col-12 mb-4">
            <template>
              <div class="card">
                <router-link :to="item.href">
                  <img class="card-img-top" :src="item.image" alt="Card image cap" style="padding: 10px"
                /></router-link>
                <div class="card-body">
                  <h5 class="card-title" style="letter-spacing: -0.02rem" v-html="$t(item.title)"></h5>
                  <p class="card-text">{{ $t(item.desc) }}</p>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';

export default {
  name: 'Program',
  data() {
    return {
      program_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'PROGRAM',
        present: this.$t('breadcrumb'),
      },
      program_items: [
        // {
        //   title: '그린사이드BBQ&힐링',
        //   desc: '초록 잔디 위 특별한 만찬과 프리미엄 스파까지 로맨틱한 저녁의 완성',
        //   image: require('@/assets/images/pleisure/program/grbbqandspa_main_01.jpg'),
        //   href: '/p/grbbqandspa',
        // },
        {
          title: 'program1_title',
          desc: 'program1_desc',
          image: require('@/assets/images/pleisure/program/luxuryyacht_main_01.jpg'),
          href: '/p/luxuryyacht',
        },
        {
          title: 'program2_title',
          desc: 'program2_desc',
          image: require('@/assets/images/pleisure/program/nobleriding_main_01.jpg'),
          href: '/p/nobleriding',
        },
        {
          title: 'program3_title',
          desc: 'program3_desc',
          image: require('@/assets/images/pleisure/program/jejufisherman_main_01.jpg'),
          href: '/p/jejufisherman',
        },
        {
          title: 'program4_title',
          desc: 'program4_desc',
          image: require('@/assets/images/pleisure/program/happytogether_main_01.jpg'),
          href: '/p/happytogether',
        },
        {
          title: 'program5_title',
          desc: 'program5_desc',
          image: require('@/assets/images/pleisure/program/forestorytellingtour_main_01.jpg'),
          href: '/p/forestorytellingtour',
        },
        {
          title: 'program6_title',
          desc: 'program6_desc',
          image: require('@/assets/images/pleisure/program/challengergolf_main_01.jpg'),
          href: '/p/challengergolf',
        },
        {
          title: 'program7_title',
          desc: 'program7_desc',
          image: require('@/assets/images/pleisure/program/artnhealing_main_01.jpg'),
          href: '/p/artnhealing',
        },
        {
          title: 'program8_title',
          desc: 'program8_desc',
          image: require('@/assets/images/pleisure/program/podoarttour_main_01.jpg'),
          href: '/p/podoarttour',
        },
        // 현업 요청 23.04.12 프로그램 게시 중단
        /*{
          title: 'program8_title',
          desc: 'program8_desc',
          image: require('@/assets/images/pleisure/program/privateyoga_main_01.jpg'),
          href: '/p/privateyoga',
        },*/
      ],
    };
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }

      this.program_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'PROGRAM',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  components: {Breadcrumb},
};
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}

.top {
  padding-top: 11rem;
}

.card-text {
  margin-bottom: 13px;
  font-size: 14px;
  opacity: 0.7;
  word-break: keep-all;
}
.card-body {
  height: 10rem;
  padding-top: 12px;
}
td {
  border-bottom: 1px dashed #cdcdcd;
}

.headerimage {
  width: 100%;
  margin: 0;
  content: url('~@/assets/images/common/programInfo_headerimage.jpg');
}
.program_info {
  width: 100%;
  margin: 0;
  content: url('~@/assets/images/pleisure/program_info_img.png');
}
@media (max-width: 992px) {
  .headerimage {
    display: none;
  }

  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: lighter;
      letter-spacing: -0.1rem;
    }
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "프로그램 안내",
    "program_title": "프로그램 안내",
    "program_desc": "High-end 고객을 위한 프리미엄 레저 프로그램",
    "program1_title": "프라이빗 럭셔리요트",
    "program1_desc": "제주 최고의 요트에서 즐기는 스페셜 럭셔리 제주 여행",
    "program2_title": "노블승마",
    "program2_desc": "전문 교관의 정통 승마 강습부터 외승 체험까지",
    "program3_title": "제주 어부",
    "program3_desc": "제주 바다를 고스란히 느끼는 익스트림 액티비티",
    "program4_title": "해피투게더",
    "program4_desc": "제주의 숲, 식물 이야기",
    "program5_title": "제주 숲토리텔링 투어",
    "program5_desc": "숲토리텔러와 함께하는 프라이빗 숲 트레킹",
    "program6_title": "챌린저 골프",
    "program6_desc": "한국 최초의 세계 100대 골프장 핀크스에서 경험하는 프리미엄 골프 레슨 프로그램",
    "program7_title": "아트앤힐링",
    "program7_desc": "세계적 건축가와 예술가의 손길을 따라서",
    "program8_title": "포도 아트 투어",
    "program8_desc": "자연과 함께 숨쉬는 건축, 포도호텔 건축 예술을 느끼다."
  },
  "en": {
    "breadcrumb": "Program Information",
    "program_title": "Program Information",
    "program_desc": "Premium leisure program for high-end customers.",
    "program1_title": "Private Luxury Yacht",
    "program1_desc": "Special and luxury journey on the best yacht in Jeju Island.",
    "program2_title": "Noble Horseback Riding",
    "program2_desc": "Authentic horseback riding lesson and outdoor riding experience.",
    "program3_title": "Jeju Fisherman",
    "program3_desc": "Extreme activity to feel pure Jeju Sea.",
    "program4_title": "Happy Together<br/>(Forest storytelling)",
    "program4_desc": "Story about Jeju forest and plants.",
    "program5_title": "Jeju Sooptorytelling Tour<br/>(Forest Trekking)",
    "program5_desc": "Private forest trekking with the forest storyteller.",
    "program6_title": "Challenger Golf",
    "program6_desc": "Premium golf lesson in Korea's first top 100 golf courses in the world.",
    "program7_title": "Art & Healing",
    "program7_desc": "Following footsteps of the world-renowned architects and artists.",
    "program8_title": "Podo Art Tour",
    "program8_desc": "Feel the artistic architecture, PODO Hotel that breathes with nature."
  },
  "ja": {
    "breadcrumb": "프로그램 안내",
    "program_title": "프로그램 안내",
    "program_desc": "High-end 고객을 위한 프리미엄 레저 프로그램",
    "program1_title": "프라이빗 럭셔리요트",
    "program1_desc": "제주 최고의 요트에서 즐기는 스페셜 럭셔리 제주 여행",
    "program2_title": "노블승마",
    "program2_desc": "전문 교관의 정통 승마 강습부터 외승 체험까지",
    "program3_title": "제주 어부",
    "program3_desc": "제주 바다를 고스란히 느끼는 익스트림 액티비티",
    "program4_title": "해피투게더",
    "program4_desc": "제주의 숲, 식물 이야기",
    "program5_title": "제주 숲토리텔링 투어",
    "program5_desc": "숲토리텔러와 함께하는 프라이빗 숲 트레킹",
    "program6_title": "챌린저 골프",
    "program6_desc": "한국 최초의 세계 100대 골프장 핀크스에서 경험하는 프리미엄 골프 레슨 프로그램",
    "program7_title": "아트앤힐링",
    "program7_desc": "세계적 건축가와 예술가의 손길을 따라서",
    "program8_title": "프라이빗 힐링 요가",
    "program8_desc": "제주의 아름다운 풍경과 함께하는 스페셜 요가"
  }
}
</i18n>
